import styles from '../SessionsAuthHeader.module.css'

export interface StaticUserAvatarProps {
  userName: string
  avatarUrl: string
}

const StaticUserAvatar = ({userName, avatarUrl}: StaticUserAvatarProps) => {
  return (
    <>
      <div className={styles.authFormHeaderIcon}>
        <div className={styles.authFormAvatarWrapperStatic}>
          <img src={avatarUrl} alt={`Avatar of ${userName}`} className={styles.userAvatar} />
        </div>
      </div>
    </>
  )
}

export default StaticUserAvatar

try{ StaticUserAvatar.displayName ||= 'StaticUserAvatar' } catch {}